import Combobox from '../Combobox';

/**
 * Form Model of Combobox Multiselect. Here we keep track of the selected values.
 *
 * This is, like the whole component, tightly coupled for Announcements and PersonCollection.
 */
export default class ComboboxMultiSelectFormModel extends Combobox {
  constructor(parameter) {
    super(parameter);

    // initialized or dynamically enriched with Items for either Announcements or PersonCollection
    this.selectedItems = [];

    // initial array needed only to compare
    this.initialSelectedItems = [];
    this.hasReadProtectedItems = false;

    this.addParameterToSelectedList = this.addParameterToSelectedList.bind(this);
    this.removeParameterByTitle = this.removeParameterByTitle.bind(this);
    this.removeParameterById = this.removeParameterById.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getPayloadValue = this.getPayloadValue.bind(this);

    this.initializeWithValuesFromBackend(parameter);
  }

  /**
   * Initializes the selectedItems with the values provided in JSON by backend.
   */
  initializeWithValuesFromBackend(parameter) {
    this.hasReadProtectedItems = parameter.hasReadProtectedItems === true || false;
    if (parameter.value && parameter.value.length > 0) {
      parameter.value.forEach(param => {
        if (this.isPersonCollectionParameter(param)) {
          this.initialSelectedItems.push(param);
          this.addParameterToSelectedList(param);
        } else {
          this.initializeKeywordParameter(param);
        }
      });
    }
  }

  initializeKeywordParameter(parameter) {
    this.initialSelectedItems.push(parameter);
    this.addParameterToSelectedList(parameter);
  }

  /**
   * Checking if the parameter is of type Persons, which is the parameter for PersonCollection.
   * currently we assume the parameter has profileName in it.
   * this is not a good idea.
   * @returns {boolean}
   */
  isPersonCollectionParameter = parameter => {
    return !!parameter.profileName;
  };

  /**
   * Adding a selected item to the list.
   * This bit is for Personcollection, where we dont need a real FormModel-Parameter.
   *
   * Via maxSelectableItems you can set limit for selectable items
   * */
  addParameterToSelectedList(parameter, maxSelectableItems, addAtPosition = 'end') {
    if (!this.selectedItems.find(p => p.id === parameter.id)) {
      if (addAtPosition === 'end') {
        if (maxSelectableItems && this.selectedItems.length === maxSelectableItems) {
          this.selectedItems[maxSelectableItems - 1] = parameter;
        } else {
          this.selectedItems.push(parameter);
        }
      } else if (addAtPosition === 'start') {
        if (maxSelectableItems && this.selectedItems.length === maxSelectableItems) {
          this.selectedItems[0] = parameter;
        } else {
          this.selectedItems.unshift(parameter);
        }
      }
    }
    this.broadcast();
  }

  /**
   * Remove by Parameter title/solr ID as label is not unique.
   */
  removeParameterByTitle(parameterTitle) {
    if (this.selectedItems.find(parameter => parameter.title === parameterTitle)) {
      this.selectedItems = this.selectedItems.filter(parameter => parameter.title !== parameterTitle);
      this.broadcast();
    }
  }

  /**
   * Remove ID in selectedItems.
   */
  removeParameterById(selectedItem) {
    if (this.selectedItems.find(parameter => parameter.id === selectedItem.id)) {
      this.selectedItems = this.selectedItems.filter(parameter => parameter.id !== selectedItem.id);
      this.broadcast();
    }
  }

  onChange(parameterName, value) {
    const foundParam = this.selectedItems.find(parameter => parameter.title === parameterName);

    if (foundParam) {
      foundParam.value = value;
      this.broadcast();
    }
  }

  onSortOrderChanged(newList) {
    this.selectedItems = newList;
    this.broadcast();
  }

  // often called as "hasChanges" to enable the submit button;
  valueChanged() {
    for (let i = 0; i < this.selectedItems.length; i += 1) {
      const param = this.selectedItems[i];

      const foundItemIndex = this.initialSelectedItems.findIndex(initParam => {
        return initParam.id === param.id;
      });

      if (foundItemIndex === -1 || foundItemIndex !== i) {
        return true;
      }
    }
    return this.selectedItems.length !== this.initialSelectedItems.length;
  }

  /**
   * Own extract payload implementation of this combobox. found jsonExtractor.js.
   */
  getPayloadValue() {
    if (this.selectedItems.length === 0) {
      return null;
    }

    return Object.keys(this.selectedItems).map((key, index) => {
      return {
        name: `${this.name}[${index}].id`,
        value: this.selectedItems[key].id,
      };
    });
  }
}
